import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logoColor from "../../assets/galaxy-labs-logo.png";
import chrityBlack from "../../assets/charityBlack.png";
import charityWhite from "../../assets/charitiesWhite.png";

const Sidebars = ({ sendDataToParent }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location?.pathname;
  const [manageRetailerISOPen, setManageRetailerISOPen] = useState(false);
  const [manageCategoryOpen, setManageCategoryOpen] = useState(false);
  const [manageRetailerMenu, setManageRetailerMenu] = useState("retailerList");
  const [manageCategoryMenu, setManageCategoryMenu] = useState("productCategory");

  const manageCategoryHandler = (e) => {
    e.preventDefault();
    setManageCategoryOpen(!manageCategoryOpen);
    navigate("/manage-categories");
  };

  useEffect(() => {
   
    if (currentPath === "/manage-categories") {
      setManageCategoryOpen(!manageCategoryOpen);
    }
  }, [currentPath]);

  const ratailerListHandler = (e, data) => {
    e.preventDefault();
    sendDataToParent(data);
    setManageRetailerMenu(data);
  };
  const productCategoryHandler = (e, data) => {
    e.preventDefault();
    sendDataToParent(data);
    setManageCategoryMenu(data);
  };

  return (
    <aside id="sidebar" className="sidebar">
      <div className="mb-4">
        <a href="" className="logo">
          <img src={logoColor} alt="logo" className="img-fluid" />
        </a>
      </div>
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          <Link
            className={`nav-link ${
              currentPath === "/manage-categories" ? "" : "collapsed"
            }`}
            to={"/manage-categories"}
          >
            <i className="bi bi-grid-1x2-fill"></i>
            <span>Manage Categories</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={`nav-link ${
              currentPath == "/manage-products" ? "" : "collapsed"
            }`}
            to={"/manage-products"}
          >
            <i className="bi bi-inboxes-fill"></i>
            <span>Manage Products</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className={`nav-link ${currentPath === "/order-settings" ? "" : "collapsed"}`}
            to={"/order-settings"}
          >
            <i className="bi bi-gear-fill me-2"></i>
            <span>Order Settings</span>
          </Link>
        </li>
       
        {/* <li className="nav-item">
          <Link
            className={`nav-link ${
              currentPath === "/sale-fee-management" ? "" : "collapsed"
            }`}
            to={"/sale-fee-management"}
          >
            <i className="bi bi-cash-stack"></i>
            <span>Sales Fee Management</span>
          </Link>
        </li> */}
        <></>
        
       
        <li className="nav-item">
          <Link
            className={`nav-link ${
              currentPath === "/social-links" ? "" : "collapsed"
            }`}
            to={"/social-links"}
          >
            <i className="bi bi-image"></i>
            <span>Social Links</span>
          </Link>
        </li>
       
       
       
        
        
        
        <li className="nav-item">
          <Link
            className={`nav-link ${
              currentPath === "/about-content" ? "" : "collapsed"
            }`}
            to={"/static-content"}
          >
            <i className="bi bi-file-earmark-text-fill"></i>
            <span>Static Content</span>
          </Link>
        </li>
        


        
        
        <li className="nav-item">
          <Link
            className={`nav-link ${
              currentPath === "/eligibility-shopping" ? "" : "collapsed"
            }`}
            to={"/eligibility-shopping"}
          >
            <i className="bi bi-bag-check-fill"></i>

            <span>Eligibility Shopping</span>
          </Link>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebars;
